import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const TermsConditions = () => {
  return (
    <div className="bg-white min-h-screen flex flex-col">
      <Header />

      <main className="flex-1 pt-28 md:pt-32">
        <section className="py-12">
          <div className="max-w-5xl mx-auto px-4 prose prose-lg text-gray-700">
            <h1 className="text-4xl font-semibold text-[#2563EB] mb-8 text-center">
              Terms and Conditions
            </h1>

            <p>
              Welcome to <strong>HPR Infra</strong>. These Terms and Conditions
              govern your access to and use of our website, mobile site, and any
              other online platforms or services that link to these Terms
              (collectively, the “
              <a
                href="https://hprinfra.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline"
              >
                https://hprinfra.com/
              </a>
              ”). By accessing or using the Website, you agree that you have
              read, understood, and agreed to be bound by these Terms. If you do
              not agree with these Terms, please do not use this Website.
            </p>

            <h2 className="text-2xl font-semibold mt-10 mb-4">
              1. Use of the Website
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                You must be at least 18 years old and capable of entering into a
                legally binding agreement to use this Website.
              </li>
              <li>
                You agree to use the Website only for lawful purposes and in
                accordance with applicable laws, rules, and regulations in
                India.
              </li>
              <li>
                You agree not to:
                <ul className="list-disc pl-6 mt-2 space-y-1">
                  <li>
                    misuse the Website or attempt to gain unauthorised access to
                    any part of it;
                  </li>
                  <li>
                    introduce any viruses, malicious code, or harmful material;
                  </li>
                  <li>
                    use the Website to host, display, upload, modify, publish,
                    transmit, update, or share any information that is
                    defamatory, obscene, infringing, unlawful, or otherwise
                    objectionable.
                  </li>
                </ul>
              </li>
            </ul>
            <p className="mt-4">
              We may, at our sole discretion, restrict or suspend your access to
              the Website if we believe you have violated these Terms.
            </p>

            <h2 className="text-2xl font-semibold mt-10 mb-4">
              2. Project Information, Pricing & Availability
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                The information on projects, including apartments, villas, and
                HMDA-approved plotted developments, is provided for general
                information and marketing purposes only.
              </li>
              <li>
                Project details such as layout plans, specifications, amenities,
                areas, possession timelines, approvals, licenses, and pricing
                are subject to change without prior notice, in line with
                applicable laws and directions of competent authorities.
              </li>
              <li>
                Images, renderings, walkthroughs, and visuals shown on the
                Website are often artistic impressions or indicative in nature.
                Actual construction, materials, colours, and finishes may vary
                at the time of completion.
              </li>
              <li>
                All areas mentioned are as per the applicable norms and may be
                subject to variation due to site conditions, statutory changes,
                or technical reasons.
              </li>
              <li>
                Any prices, payment plans, offers, schemes, or financing
                information displayed on the Website are indicative and subject
                to specific terms in official documents.
              </li>
            </ul>
            <p>
              Nothing on this Website constitutes a legally binding offer or
              contract. Purchases shall be governed solely by executed
              agreements between the buyer and the Company.
            </p>

            <h2 className="text-2xl font-semibold mt-10 mb-4">
              3. Regulatory Approvals & RERA
            </h2>
            <p>
              Projects are registered under the Real Estate (Regulation and
              Development) Act, 2016 (“RERA”) and relevant state rules. RERA
              registration numbers and approval details are provided on
              respective project pages or via official documentation. Buyers are
              advised to verify details through official RERA websites and
              review title and sanction documents.
            </p>

            <h2 className="text-2xl font-semibold mt-10 mb-4">
              4. No Professional or Investment Advice
            </h2>
            <p>
              Website content does not constitute legal, financial, or
              investment advice. Users should seek independent professional
              advice before making decisions related to our projects.
            </p>

            <h2 className="text-2xl font-semibold mt-10 mb-4">
              5. Intellectual Property Rights
            </h2>
            <p>
              All content, including text, layouts, graphics, and logos, are
              owned by or licensed to <strong>HPR Infra</strong> and protected
              under applicable laws. You may view or print pages for personal,
              non-commercial use only. Unauthorized copying, modification, or
              distribution is prohibited.
            </p>

            <h2 className="text-2xl font-semibold mt-10 mb-4">
              6. User Enquiries, Submissions & Communication
            </h2>
            <p>
              By submitting enquiry forms or contacting us, you authorize us to
              communicate with you via phone, SMS, WhatsApp, or email regarding
              projects and services, even if your number is on a “Do Not
              Disturb” list, as permitted by law.
            </p>

            <h2 className="text-2xl font-semibold mt-10 mb-4">
              7. Third-Party Links, Banks & Services
            </h2>
            <p>
              The Website may contain links to third-party services. We are not
              responsible for their content, privacy practices, or accuracy.
              Accessing them is at your own risk.
            </p>

            <h2 className="text-2xl font-semibold mt-10 mb-4">
              8. Disclosure of Your Information
            </h2>
            <p>
              We may share information we have collected about you in certain
              situations. Your information may be disclosed as follows:
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-2">
              By Law or to Protect Rights
            </h3>
            <p>
              If we believe the release of information about you is necessary to
              respond to legal process, to investigate or remedy potential
              violations of our policies, or to protect the rights, property,
              and safety of others, we may share your information as permitted
              or required by any applicable law, rule, or regulation. This
              includes exchanging information with other entities for fraud
              protection and credit risk reduction.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-2">
              Third-Party Service Providers
            </h3>
            <p>
              We may share your information with third parties that perform
              services for us or on our behalf, including payment processing,
              data analysis, email delivery, hosting services, customer service,
              and marketing assistance.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-2">
              Marketing Communications
            </h3>
            <p>
              With your consent, or with an opportunity for you to withdraw
              consent, we may share your information with third parties for
              marketing purposes, as permitted by law.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-2">
              Third-Party Advertisers
            </h3>
            <p>
              We may use third-party advertising companies to serve ads when you
              visit the Application. These companies may use information about
              your visits to the Application and other websites that are
              contained in web cookies in order to provide advertisements about
              goods and services of interest to you.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-2">Affiliates</h3>
            <p>
              We may share your information with our affiliates, in which case
              we will require those affiliates to honor this Privacy Policy.
              Affiliates include our parent company and any subsidiaries, joint
              venture partners, or other companies that we control or that are
              under common control with us.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-2">
              Business Partners
            </h3>
            <p>
              We may share your information with our business partners to offer
              you certain products, services, or promotions.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-2">
              Other Third Parties
            </h3>
            <p>
              We may share your information with advertisers and investors for
              the purpose of conducting general business analysis. We may also
              share your information with such third parties for marketing
              purposes, as permitted by law.
            </p>

            <p>
              We are not responsible for the actions of third parties with whom
              you share personal or sensitive data, and we have no authority to
              manage or control third-party solicitations. If you no longer wish
              to receive correspondence, emails, or other communications from
              third parties, you are responsible for contacting the third party
              directly.
            </p>

            <h2 className="text-2xl font-semibold mt-10 mb-4">
              9. Disclaimer of Warranties
            </h2>
            <p>
              The Website is provided “as is” without warranties of any kind. We
              do not guarantee that information is always accurate, error-free,
              or secure.
            </p>

            <h2 className="text-2xl font-semibold mt-10 mb-4">
              10. Limitation of Liability
            </h2>
            <p>
              To the maximum extent permitted by law, <strong>HPR Infra</strong>{" "}
              shall not be liable for any direct, indirect, or consequential
              losses arising from use of the Website or reliance on its content.
            </p>

            <h2 className="text-2xl font-semibold mt-10 mb-4">11. Indemnity</h2>
            <p>
              You agree to indemnify and hold harmless{" "}
              <strong>HPR Infra</strong>, its directors, officers, and
              affiliates from any claims or damages arising from your use of the
              Website or violation of these Terms.
            </p>

            <h2 className="text-2xl font-semibold mt-10 mb-4">
              12. Changes to Website, Projects & Terms
            </h2>
            <p>
              We may modify or update Website content, project information, or
              these Terms without prior notice. Continued use implies acceptance
              of any such changes.
            </p>

            <h2 className="text-2xl font-semibold mt-10 mb-4">
              13. Governing Law & Jurisdiction
            </h2>
            <p>
              These Terms are governed by the laws of India. The courts at South
              India, Telangana, shall have exclusive jurisdiction for any
              disputes arising from these Terms or your use of the Website.
            </p>

            <h2 className="text-2xl font-semibold mt-10 mb-4">
              14. Severability
            </h2>
            <p>
              If any provision of these Terms is held invalid or unenforceable,
              the remaining provisions will continue in full effect.
            </p>

            <h2 className="text-2xl font-semibold mt-10 mb-4">
              15. Contact Us
            </h2>
            <address className="not-italic text-gray-700 leading-relaxed">
              <strong>HPR Infra</strong> <br />
              101, Silicon Towers, <br />
              Image Garden Road, <br />
              Madhapur, Hyderabad - 500081 <br />
              <strong>Phone:</strong> 40-40036841 <br />
              <strong>Email:</strong>{" "}
              <a
                href="mailto:hprinfrallp@gmail.com"
                className="text-blue-600 underline"
              >
                contact@hprinfra.com
              </a>
            </address>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default TermsConditions;
